import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
}

export default function Footer({ className = '' }: FooterProps) {
  return (
    <footer className={`bg-green-900 text-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10 lg:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="text-xl sm:text-2xl font-pacifico text-green-300 mb-3 sm:mb-4">AyurVeda</div>
            <p className="text-green-100 mb-4 text-sm sm:text-base leading-relaxed">
              Your trusted partner in natural wellness and Ayurvedic healing. 
              Discover the power of ancient wisdom for modern health.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-green-800 rounded-full hover:bg-green-700 transition-colors">
                <i className="ri-facebook-fill text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-green-800 rounded-full hover:bg-green-700 transition-colors">
                <i className="ri-instagram-line text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-green-800 rounded-full hover:bg-green-700 transition-colors">
                <i className="ri-twitter-line text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-green-800 rounded-full hover:bg-green-700 transition-colors">
                <i className="ri-youtube-line text-sm sm:text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-green-300">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Home</Link></li>
              <li><Link to="/products" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Products</Link></li>
              <li><Link to="/about" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">About Us</Link></li>
              <li><Link to="/contact" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Contact</Link></li>
              <li><Link to="/blog" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Health Blog</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-green-300">Categories</h3>
            <ul className="space-y-2">
              <li><Link to="/products?category=weight-loss" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Weight Loss</Link></li>
              <li><Link to="/products?category=joint-pain" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Joint Pain</Link></li>
              <li><Link to="/products?category=immunity" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Immunity</Link></li>
              <li><Link to="/products?category=skin-care" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Skin Care</Link></li>
              <li><Link to="/products?category=digestive" className="text-green-100 hover:text-white transition-colors text-sm sm:text-base">Digestive Health</Link></li>
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-green-300">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-300 text-sm sm:text-base"></i>
                <span className="text-green-100 text-sm sm:text-base">+91 8815239465</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-green-300 text-sm sm:text-base"></i>
                <span className="text-green-100 text-sm sm:text-base break-all">nirvanaayurveda486@gmail.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-green-300 mt-1 text-sm sm:text-base"></i>
                <span className="text-green-100 text-sm sm:text-base leading-relaxed">Hospital road<br />Balvihar vidisha<br />madhya pradesh 464001</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-green-800 mt-6 sm:mt-8 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-green-100 text-xs sm:text-sm text-center sm:text-left">
            © 2024 AyurVeda. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center sm:justify-end space-x-4 sm:space-x-6 mt-3 sm:mt-0">
            <Link to="/privacy" className="text-green-100 hover:text-white text-xs sm:text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-green-100 hover:text-white text-xs sm:text-sm transition-colors">
              Terms of Service
            </Link>
            <Link to="/shipping" className="text-green-100 hover:text-white text-xs sm:text-sm transition-colors">
              Shipping Info
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}